import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-info-box',
  standalone: true,
  imports: [NzIconModule],
  templateUrl: './info-box.component.html',
  styleUrl: './info-box.component.scss',
})
export class InfoBoxComponent implements OnInit, OnDestroy {
  @Input() title!: string;
  @Input() description!: string;
  @Input() cssProperties?: { [key: string]: string | number };
  @Input() iconOptions?: { type: string; theme: 'outline' | 'fill' | 'twotone' };
  isDesktop: boolean = true;


  ngOnInit(): void {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));  
  }

  checkScreenSize() {
    this.isDesktop = window.innerWidth >= 768;
  }
  
  ngOnDestroy() {
    window.removeEventListener('resize', this.checkScreenSize.bind(this));
  }
}
